<template>
  <div style=" background-color: #FFFFFF;">
    <el-tabs v-if="navType == 'tab'" v-model="activePage.path" type="card" @tab-click="tabClick" @tab-remove="removeTab" addable
      @edit="handleTabsEdit">
      <el-tab-pane v-for="item in openedPageList" :closable="true" :key="item.id" :label="item.name" :name="item.path">
      </el-tab-pane>
    </el-tabs>


     <div v-else  class="menu-tabbar">
      <span v-for="item in openedPageList" :key="item.id" class="menu-tags">
        <el-tag v-if="item.path == activePage.path" effect="dark" closable @close="handleClose(item)"
          @click="handleClick(item)">
          {{item.name}}
        </el-tag>
        <el-tag v-else size="small" effect="plain" closable @close="handleClose(item)" @click="handleClick(item)">
          {{item.name}}
        </el-tag>
      </span>
      <el-tag class="menu-tags-close" size="small" type="danger" @click="handleCloseAll(item)">关闭全部</el-tag>
      </div>
  </div>
</template>
<script>
  import {
    mapState,
    mapGetters
  } from 'vuex'
    import tools from '@/tools'
  export default {
    computed: {
      // ...mapGetters(['navType']),
      ...mapState({
        openedPageList: state => state.tabsbar.openedPageList,
        activePage: state => state.tabsbar.activePage,
        navType: state => state.settings.navType,
      })
    },
    data() {
      return {
        cardBodyStyle: tools.style.card,

      }
    },

    mounted() {

    },
    methods: {
      handleClick(item) {
        console.log(JSON.stringify(item))
        this.$router.push(item.path);
      },
      handleClose(item) {
        console.log(JSON.stringify(item))
        var path = item.path
        if (path === '/home/main') {
          return
        }
        let tabs = this.openedPageList;
        if (this.activePage.path === path) {
          //console.log(1111)
          tabs.forEach((tab, index) => {
            if (tab.path === path) {
              let nextTab = tabs[index - 1] || tabs[index + 1];
              if (nextTab) {
                //console.log('nextTab.path'+nextTab.path)
                this.$router.push(nextTab.path)

              }
            }
          });
        }
        this.$store.commit('removeTab', path)
      },

      handleCloseAll(item) {
        console.log(item)
        this.$store.commit('setOpenedPageList', [{
          name: "主页",
          path: "/home/main"
        }])
        this.$router.push('/home/main');
      },


      handleTabsEdit(targetName, action) {
        if (action == 'add') {
          this.$store.commit('setOpenedPageList', [{
            name: "主页",
            path: "/home/main"
          }])
          this.$router.push('/home/main');
        }
      },
      tabClick(tab) {
        this.$router.push(tab.name);
      },
      removeTab(path) {
        // 				console.log(this.activePage.path)
        //	console.log(path)
        if (path === '/home/main') {
          return
        }
        let tabs = this.openedPageList;
        if (this.activePage.path === path) {
          //console.log(1111)
          tabs.forEach((tab, index) => {
            if (tab.path === path) {
              let nextTab = tabs[index - 1] || tabs[index + 1];
              if (nextTab) {
                //console.log('nextTab.path'+nextTab.path)
                this.$router.push(nextTab.path)

              }
            }
          });
        }
        this.$store.commit('removeTab', path)
      }

    },



  }
</script>
<style>
  .menu-tabbar {
    padding: 5px 5px 5px 10px;
    display: flex;
    align-items: center;
  }

  .menu-tags {
    margin: 3px 3px 0px 3px;
  }

  .menu-tags-close {
    margin: 3px 3px 0px 3px;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/home/TabBar.vue